import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4">
      <p className="text-sm text-muted-foreground mb-2">404</p>
      <h1 className="text-2xl font-bold mb-4">Page not found</h1>
      <Link to="/" className="text-primary hover:underline">
        Back to home
      </Link>
    </div>
  );
}
